import React from "react";

import styles from "./Divider.module.scss";

export function Divider() {
  return <div className={styles.Divider} />
}

